// errorHandling.js
const parseErrorResponse = (error) => {
  const unexpectedError = { code: 'unexpected', message: 'An unexpected error occurred.' };
  if (!error.response || !error.response.data) return unexpectedError;
  try {
    const apiError = error.response.data;
    return apiError;
  } catch (parseError) {
    return unexpectedError;
  }
};

export default parseErrorResponse;
